'use client';
import { getPersonFullName } from 'src/cms/utils/utils';
import type { IPersonFields } from 'types/generated/contentful';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Clickable } from '../actions';
import { Avatar } from '../Avatar';

interface Props {
  person: IPersonFields;
}

const AuthorAvatar = ({ person }: Props) => {
  const fullName = getPersonFullName(person);

  return (
    <Box
      flexDirection={['row', null, null, 'column']}
      maxWidth={[null, null, null, '134px']}
      alignItems={['center', null, null, 'flex-start']}
      pb={['space2', null, null, 'space0']}
      mb={['space2', null, null, 'space0']}
    >
      <Avatar
        url={person.image.fields.file.url}
        alt={`Image of ${fullName}`}
        size={48}
      />
      <Box ml={['space2', null, null, 'space0']}>
        <Text
          fontSize="87.5"
          fontWeight="semiBold"
          color="text"
          lineHeight="relaxed"
          mt="space2"
        >
          {fullName}
        </Text>
        <Text fontSize="87.5" lineHeight="relaxed">
          {person.role}
        </Text>
      </Box>
    </Box>
  );
};

export const Author = ({ person }: Props) => {
  if (person.authorDescription && person.slug) {
    return (
      <Clickable
        href={`/author/${person.slug}`}
        extend={() => ({
          transition: 'transform 0.3s ease',
          ':hover': {
            opacity: 1,
            transform: 'translateY(-8px)',
          },
        })}
      >
        <AuthorAvatar person={person} />
      </Clickable>
    );
  }
  return <AuthorAvatar person={person} />;
};
